Ext.define('WindowRejestrujSkpulite', {
    extend: 'Ext.ux.window.WindowExd',
    alias: 'widget.app.WindowRejestrujSkpulite',
    closable: false,
    collapsible: false,
    scrollable: false,
    modal: true,
    resizable: false,
    border: true,
    width: 500,
    height: 300,
    layout: 'fit',
    title: Lang.rejestracja_nowego_skpulite.capitalise(),
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: "panelcardexd",
            itemId: "panelcardexdown",
            items: [{
                xtype: "panel",
                layout: "fit",
                itemId: "startForm",
                flex: 1,
                items: [{
                    xtype: "form",
                    defaults: {
                        labelAlign: "top"
                    },
                    flex: 1,
                    columnWidth: 1,
                    bodyStyle: 'padding:10px 10px 100px 10px',
                    items: [{
                        xtype: 'textfieldexd',
                        id: this.cid + "serialnumber",
                        fieldLabel: Lang.numer_seryjny.capitalise(),
                        anchor: '0',
                        allowBlank: false,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste.capitalise()
                    }],
                    buttons: [{
                        text: Lang.dalej.capitalise(),
                        clickEvent: "click",
                        scope: this,
                        handler: this.performNextStep
                    }, {
                        text: Lang.zamknij.capitalise(),
                        clickEvent: "click",
                        scope: this,
                        handler: this.close
                    }]
                }]
            }, {
                xtype: "panel",
                layout: "fit",
                itemId: "resultForm",
                items: [{
                    xtype: "form",
                    defaults: {
                        labelAlign: "top",
                    },
                    columnWidth: 1,
                    bodyStyle: 'padding:10px 10px 145px 10px',
                    items: [{
                        xtype: 'label',
                        id: this.cid + "resultText",
                        html: ''
                    }],
                    buttons: [{
                        text: Lang.zamknij.capitalise(),
                        clickEvent: "click",
                        scope: this,
                        handler: this.close
                    }]
                }]
            }]
        }];
        this.callParent(arguments);
    },
    show: function () {
        this.callParent(arguments);
    },
    afterRender: function () {
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.callParent(arguments);
    },
    performNextStep: function () {
        var serialnumber = Ext.getCmp(this.cid + "serialnumber").getValue();
        if (serialnumber == null || serialnumber == '') {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        var resultText = Ext.getCmp(this.cid + "resultText");
        this.mask(Lang.przetwarzanie_danych);
        performAjaxLPromise("rest/skpulite/isRegistrationAvailable", {serialnumber: serialnumber})
            .then(d => {
                if (d) {
                    return new Promise(function (resolve, reject) {
                        var window = Ext.create('WindowSkpulite');
                        let success = false;
                        window.showW(0, serialnumber);
                        window.on("closesuccess", function () {
                            success = true;
                        })
                        window.on("close", function () {
                            resolve(success);
                        })
                    });
                } else {
                    return "notallowed";
                }
            })
            .then(d => {
                if (d == "notallowed") {
                    resultText.setText(Lang.nie_istnieje_skpulite_o_takim_numerze_seryjnym.capitalise());
                } else if (d) {
                    resultText.setText(Lang.skpulite_zostalo_zarejestrowano.capitalise());
                } else {
                    resultText.setText(Lang.blad_przy_rejestracji_skpulite.capitalise());
                }
                var layout = this.down("#panelcardexdown").getLayout();
                layout.setActiveItem("resultForm");
            })
            .catch(e => {
                handleCommonCallBackAjaxRPCError(e);
            })
            .finally(() => {
                this.unmask();
                if (this.callbackF)
                    this.callbackF();
            });
    },
    close: function () {
        this.callParent();
    }
});